export default {
  mounted () {
    window.addEventListener('scroll', this.headerSwitch)
  },
  destroyed () {
    window.removeEventListener('scroll', this.headerSwitch)
  }
}